var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPaintRoller = function SvgIconPaintRoller(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.125 10v2c0 .966.784 1.75 1.75 1.75h13.5a1.75 1.75 0 0 0 1.75-1.75v-2H21.5v4.25l-9.23 2.629-.01.003A1.76 1.76 0 0 0 11 18.554v3.196a1 1 0 1 0 2 0v-3l9.23-2.629.01-.003a1.76 1.76 0 0 0 1.26-1.672V9.75A1.75 1.75 0 0 0 21.75 8h-1.625V6a1.75 1.75 0 0 0-1.75-1.75h-13.5A1.75 1.75 0 0 0 3.125 6v2H1.5a1 1 0 0 0 0 2zm2 1.75h13v-5.5h-13z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPaintRoller;